var React = require('react');

function ThumbDown (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"currentColor","d":"M19 15V3h4v12h-4M15 3c1.105 0 2 .895 2 2v10c0 .55-.22 1.05-.59 1.41L9.83 23l-1.06-1.06c-.27-.27-.44-.64-.44-1.06l.03-.31.95-4.57H3c-1.105 0-2-.895-2-2v-2c0-.26.05-.5.14-.73l3.02-7.05C4.46 3.5 5.17 3 6 3h9m0 2H5.97L3 12v2h8.78l-1.13 5.32L15 14.97V5z","key":0}),React.createElement("path",{"fillRule":"nonzero","d":"M0 0H24V24H0z","key":1})]));
}

ThumbDown.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = ThumbDown;

ThumbDown.default = ThumbDown;
